import { Button, Tooltip } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { useGlobalState } from '@/hooks/useGlobalState'

import { uploadRunningTooltip } from './bulkUploadJobCopy'

/** Decision 34: one bulk upload at a time, so this waits out any job, in this tab or another. */
export const AddMultipleFilesButton = observer(function AddMultipleFilesButton({
  disabled,
  onClick,
}: {
  disabled: boolean
  onClick: () => void
}) {
  const { bulkUploadStore } = useGlobalState()
  const blocked = bulkUploadStore.isStartBlocked
  const button = (
    <Button variant="light" disabled={disabled || blocked} onClick={onClick}>
      Add Multiple Files
    </Button>
  )
  if (!blocked) return button
  return (
    <Tooltip label={uploadRunningTooltip} withArrow>
      <span>{button}</span>
    </Tooltip>
  )
})
